import { MaintenanceDeviceProvider } from './contexts/MaintenanceDevice.context';
import MaintenanceDeviceContent from './components/MaintenanceDeviceContent';
import buttonImage from './assets/overwatch-control.png';
import externalConfig from './configs/externalSrcConfig.json';
import { Container } from 'react-bootstrap';

export default function DeviceMaintenance() {
  return (
    <MaintenanceDeviceProvider>
      <Container fluid className="py-3">
        <div className="d-flex flex-column gap-3 justify-content-center">
          {/* Header */}
          <div className="d-flex flex-column flex-md-row space-between align-items-center">
            <h2 className="fs-4 mb-0">Maintenance Devices</h2>
            <a
              className="bg-primary-highlight rounded-4 d-flex align-items-center justify-content-center"
              href={externalConfig.inControlUrl}
              target="_blank"
              rel="noreferrer"
              style={{ height: '50px' }}
            >
              <img src={buttonImage} alt="Overwatch Control Portal" style={{ height: '40px' }} />
            </a>
          </div>
          {/* Body */}
          <MaintenanceDeviceContent />
        </div>
      </Container>
    </MaintenanceDeviceProvider>
  );
}
